import { nodeRedApi } from "../../../services/axios";

export default async function setTimer(timer) {
  try {
    const body = { timer };

    const { data } = await nodeRedApi.post("/exaustor/timer", body);

    console.log(data);
    return data;
  } catch (error) {
    const status = error?.response?.status;
    const respData = error?.response?.data;

    console.error(`Erro na requisição HTTP POST${status ? ` (${status})` : ""}:`, respData ?? error);
    return null;
  }
}